// extracted by mini-css-extract-plugin
export var admonition = "styles-module--admonition--942c4";
export var content = "styles-module--content--1eaf2";
export var info = "styles-module--info--3a80c";
export var noIcon = "styles-module--noIcon--7d80d";
export var tip = "styles-module--tip--4c6ed";
export var title = "styles-module--title--aebda";
export var warn = "styles-module--warn--d95bf";